<template>
    <div>
        <FilterTable 
          :resource_name="resource_name"
          :id="this.article_id"
          :title="title"
          :field_definitions="field_definitions"
          :filters="filters"
          :action_buttons="action_buttons"
          :row_actions="row_actions"
          :translate_to_display_data="translate_to_display_data"
          :route_root="route_root"
          :handle_row_action="handle_row_action"
          :full_text_search="false"
          :handle_action_button_click="handle_action_button_click"
          :resource_identifier="resource_identifier"
          :update_flag="filter_table_update_flag"
        />
        <el-dialog
          title=""
          :visible.sync="dialog_visible"
          width="30%"
          center>
          <DigitalObjectEditPage 
            :resource_name="resource_name"
            :route_root="route_root"
            :type="article_type"
            :resource_identifier="do_resource_identifier"
            :host_resource_identifier="resource_identifier"
            :dialog_visible="dialog_visible"
            @cancel="dialog_visible=false"
            :mode="dialog_mode"
            @update:update_flag="handle_do_update"
            :dialog_refersh="dialog_refersh_flag"
          />
        </el-dialog>
    </div>
</template>

<script>
// @ is an alias to /src
//import Main from '@/components/backstage/Main.vue'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import DigitalObjectEditPage from '@/views/backstage/pages/DigitalObjectEditPage.vue'
import PageStructure from '@/views/backstage/structure/digital_object_page/DigitalObjectEditPageStructure'
import axios from 'axios'

  export default {
    components: {
      FilterTable,
      DigitalObjectEditPage
    },
    props: ['article_type','article_id'],
    data() {
      return {
        resource_name: 'article/do',
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/article/do',
        title: '數位物件管理',
        route_root: 'digital-resource-management',
        digital_object_id: '',
        do_resource_identifier: {
          name: 'id',
          value: null
        },
        new_digital_object: {},
        file_lists: {},
        dialog_visible: false,
        dialog_refersh_flag: 0,
        dialog_mode: 'edit',
        page_structure: null,
        resource_identifier: {
          name: 'fk_article_system_id',
          value: this.article_id,
          form: 'json'
        },
        field_definitions: [
          {
            display: {
              name: '編號',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'id',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '檔案類型',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'digital_type',
              data_type: 'digital_type',
            } 
          },
          {
            display: {
              name: '縮圖',
              type: 'image',
              //width: '100px',
              sortable: false,
            },
            source: {
              type: 'db',
              key: 'preview_image_url_150',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '檔案名稱',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'original_image_name',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '敘述',
              type: 'string',
              //width: '100px',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'description',
              data_type: 'string',
            }
          },
        ],
        filters: {},
        action_buttons: {
          add: {
            label: '新增物件',
            action: 'add'
          },
        },
        row_actions: {
          edit: {
            label: '編輯',
            action: 'edit'
          },
          delete: {
            label: '刪除',
            action: 'delete',
            enable: () => this.permission_check({
              resource_info: { 
                name: this.permission.RESOURCE_DIGITAL_OBJECT_MANAGEMENT,
              },
              access: { name: this.permission.DELETE },
            })
          },
        },
        filter_table_update_flag: 0
      }
    },
    created: function () {
        console.log('EditPageDigitalObjectTab: article type:', this.article_type)

        if (!this.article_type || !this.article_id) {
          console.log('EditPageDigitalObjectTab: no article_type / article_id')
          return 
        }
        

        this.page_structure = PageStructure(this.article_type)
        console.log('EditPageDigitalObjectTab: page structure:', this.page_structure)

        let temp = this.forge_context_container(this.page_structure)
        this.new_digital_object = JSON.parse(JSON.stringify(temp))
    },
    methods: {
      translate_to_display_data(data) {
        console.log('EditPageDigitalObjectTab: translate_to_display_data')

        let types = {}
        this.field_definitions.forEach(
          function (field) {
            types[field['source']['key']] = field['source']['data_type']
          })

        let translated_data = data
        
        for (let key in data) {
          if (types[key] === 'datetime') {
            translated_data[key] = data[key].date.slice(0,-7)
          }
        }
        
        return translated_data
      },
      handle_row_action (action, index, row) {
        console.log('EditPageDigitalObjectTab: action:' + action + ', index: ' + index + ',row.id: ' + row.id +' row: ', row)

        switch(action){
          case 'edit': 
            // this.digital_object_id = row.id
            this.$set(this.do_resource_identifier, 'value', row.id)
            this.dialog_mode = 'edit'
            this.dialog_visible = true
            this.dialog_refersh_flag += 1
            break
          case 'delete': 
            this.handle_action_delete(row.id)
            break
          case 'download': 
            break  
          default:
            break
        }
      },
      handle_action_button_click (action) {
        console.log('EditPageDigitalObjectTab: action button clicked: ', action)

        switch(action){
          case 'add': 
            // this.digital_object_id = null
            this.$set(this.do_resource_identifier, 'value', null)
            this.dialog_mode = 'add'
            this.dialog_visible = true
            break
          case 'batch_download': 
            break
          default:
            break
        }
      },
      handle_action_delete (id) {
        console.log('EditPageDigitalObjectTab: delete button clicked')

        this.loading = true
        
        axios.post(this.resource_api+'/delete', {id})
            .then((response) => {
              this.loading = false
              console.log('reponse: ', response.data.payload)
              this.handle_do_update()
            })
            .catch(err => {
                this.loading = false
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法刪除', this.ERROR.MSG.general_err_msg)
            })
      },
      handle_do_update () {
        this.filter_table_update_flag += 1
      },
    }
  };
</script>

<style>
</style>
